import type { GrowthContentType } from '@mc/api'

export const CAROUSEL_SPRINGBOARD_EXP_FLAG = 'pen-5453_v1'

export type ExperimentVariants = 'control' | 'variant_1' | 'variant_2'

export type CarouselItemType = GrowthContentType | 'subcategory'

export interface CarouselImage {
  slug: string
  carouselImageURL: string
  itemType?: CarouselItemType
}

export interface CarouselItem extends CarouselImage {
  id: number
  uuid: string
  slug: string
  link: string
  title: string
  nameplateImage?: string
  nameplateText?: string
  primaryCategory?: {
    id: number
    name: string
  }
}

export interface SpringboardItem {
  uuid: string
  title: string
  totalClassesCount?: number
  sampleClasses: {
    imageUrl: string
    title: string
  }[]
}

export const homepageCarouselSpringboardImages: CarouselImage[] = [
  {
    slug: 'tell-a-great-story',
    carouselImageURL: 'https://static.masterclass.com/Carousel_Class_1.png',
  },
  {
    slug: 'chris-voss-teaches-the-art-of-negotiation',
    carouselImageURL: 'https://static.masterclass.com/Carousel_Class_12.png',
  },
  {
    slug: 'lewis-hamilton-teaches-a-winning-mindset',
    carouselImageURL: 'https://static.masterclass.com/Carousel_Class_2.png',
  },
  {
    slug: 'elevate-cooking-techniques',
    carouselImageURL: 'https://static.masterclass.com/Carousel_Subcat_3.png',
    itemType: 'subcategory',
  },
  {
    slug: 'achieve-more-with-gen-ai',
    carouselImageURL: 'https://static.masterclass.com/Carousel_Class_3.png',
  },
  {
    slug: 'scripting-your-own-success',
    carouselImageURL: 'https://static.masterclass.com/Carousel_Class_7.png',
  },
  {
    slug: 'communicate-effectively-work-teams',
    carouselImageURL: 'https://static.masterclass.com/Carousel_Subcat_1.png',
    itemType: 'subcategory',
  },
  {
    slug: 'think-like-a-sharp',
    carouselImageURL: 'https://static.masterclass.com/Carousel_Class_8.png',
  },
  {
    slug: 'brandon-mcmillan-teaches-dog-training',
    carouselImageURL: 'https://static.masterclass.com/Carousel_Class_4.png',
  },
  {
    slug: 'designing-a-home-that-tells-your-story',
    carouselImageURL: 'https://static.masterclass.com/Carousel_Class_9.png',
  },
  {
    slug: 'timbaland-teaches-producing-and-beatmaking',
    carouselImageURL: 'https://static.masterclass.com/Carousel_Class_5.png',
  },
  {
    slug: 'physical-health-sleep',
    carouselImageURL: 'https://static.masterclass.com/Carousel_Subcat_4.png',
    itemType: 'subcategory',
  },
  {
    slug: 'brain-health',
    carouselImageURL: 'https://static.masterclass.com/Carousel_Class_6.png',
  },
  {
    slug: 'a-sommelier-s-snob-free-guide-to-wine',
    carouselImageURL: 'https://static.masterclass.com/Carousel_Class_10.png',
  },
  {
    slug: 'craft-writing-process-voice',
    carouselImageURL: 'https://static.masterclass.com/Carousel_Subcat_2.png',
    itemType: 'subcategory',
  },
  {
    slug: 'cornel-west-teaches-philosophy',
    carouselImageURL: 'https://static.masterclass.com/Carousel_Class_11.png',
  },
]
